/* globals YT */
import EventEmitter from 'events';

export default class MovieBg extends EventEmitter {
  constructor() {
    super();
    this.windowW = window.innerWidth;
    this.windowH = window.innerHeight;

    window.addEventListener('resize', this.resize);
    window.addEventListener('DOMContentLoaded', () => {
      this.resize();
      this.init();
    });
    
  }
  resize() {
    this.windowW = window.innerWidth;
    this.windowH = window.innerHeight;
  }
  init() {
      var tag = document.createElement('script');
      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      // 3. This function creates an <iframe> (and YouTube player)
      //    after the API code downloads.
      let player;
      let volumeButton = document.querySelector('.js-volumeButton');
      
      window.onYouTubeIframeAPIReady = function () {
        player = new YT.Player('player', {
          height: '360',
          width: '640',
          playerVars: {
            rel: 0, // 関連動画の非表示
            controls: 0, // プレイヤーコントロールの非表示
            showinfo: 0, // タイトルなどの非表示
            modestbranding: 1, // YouTubeロゴの非表示
            iv_load_policy: 3, // アノテーションの非表示
            wmode: 'transparent'
          },
          videoId: 'TJkfcOd83N0',
          events: {
            'onReady': onPlayerReady,
            'onStateChange': onPlayerStateChange
          }
        });
      }

      function onPlayerReady(event) {
        // console.log(event.target);
        event.target.mute();
        player.seekTo('0');
        event.target.playVideo();
        player.setVolume(80);
        volumeButton.addEventListener('click', _event => {
          if(event.target.isMuted()) {
            event.target.unMute();
            volumeButton.classList.add('is-unMuted')
          } else {
            event.target.mute();
            volumeButton.classList.remove('is-unMuted')
          }
        })
      }
      var done = false;

      function onPlayerStateChange(event) {
          let movieArea = document.querySelector('.js-player')
        if (event.data == YT.PlayerState.PLAYING) {
          // console.log('play!')
          movieArea.classList.remove('is-ready')
        }
        if (event.data == YT.PlayerState.PLAYING && !done) {
          setTimeout(repeatVieo, 14000);
          // done = true;
        }
      }
      function stopVideo() {
        player.stopVideo();
      }
      function repeatVieo() {
        // console.log('repeat!')
        player.seekTo('0');
      }
    
  }
}
